import * as Localization from "expo-localization";
import { useEffect, useState } from "react";
import { AppState } from "react-native";

export function notEmpty<TValue>(
  value: TValue | null | undefined
): value is TValue {
  return value !== null && value !== undefined;
}

export function onlyUnique<T>(value: T, index: number, self: T[]) {
  return self.indexOf(value) === index;
}
export function distinct<T>(array: T[]): T[] {
  return array.filter((value, index, self) => self.indexOf(value) === index);
}

export function capitalizeFirstLetter(string: string) {
  if (!string || string.length === 0) {
    return string;
  }
  return string.charAt(0).toUpperCase() + string.slice(1);
}

export const collator = new Intl.Collator(
  Localization.getLocales()[0].languageTag
);

export function useAppState() {
  const [appState, setAppState] = useState(AppState.currentState);

  useEffect(() => {
    const el = AppState.addEventListener("change", (state) => {
      setAppState(state);
    });
    return () => {
      el.remove();
    };
  }, []);

  return appState;
}
